<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="tablet flex justify-center px-4">
      <div
        class="relative flex w-full flex-col items-start rounded bg-white p-6"
      >
        <img
          class="absolute right-4 top-4 h-4 w-4"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />

        <h3 class="header-text">Are you sure?</h3>
        <p class="mb-4 text-left text-body-color">
          {{ subtext }}
        </p>
        <div
          class="flex w-full flex-col md:ml-auto md:flex-row-reverse md:gap-x-2"
        >
          <button-main @click="$emit('delete')">
            {{ customButtonText }}
          </button-main>
          <button-main
            variant="secondary"
            class="mt-3 md:mt-0"
            @click="$emit('close')"
          >
            Cancel
          </button-main>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'ConfirmDeleteModal',
  components: {
    Modal,
    ButtonMain,
  },
  props: {
    visible: Boolean,
    subtext: {
      type: String,
      default:
        'Are you sure you want to delete this contact? This action cannot be undone. ',
    },
    customButtonText: {
      type: String,
      default: 'Yes, delete',
    },
  },
  emits: ['close', 'delete'],
  setup(_, { emit }) {
    const onCancel = () => {
      emit('close');
    };

    return {
      onCancel,
    };
  },
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .tablet {
    width: 500px;
  }
}

.header-text {
  font-size: 26px;
  @apply mb-4 text-dark-blue;
}
</style>
